import React from "react";
import moment from "moment";
import { upperFirst } from "lodash";
import { Button, Tooltip } from "antd";
import { ColumnType } from "antd/lib/table";
import { DATETIME_FORMAT, EMPTY } from "constants/common";
import { AICC_CONVERSATION_STATUS } from "constants/aicc";
import { AiccConversation } from "types/model/aiccCustomer";
import { formatDuration } from "../../../../formatDuration";
import styles from "./ConversationHistory.module.scss";

const formatDatetime = (datetime?: string) => (datetime ? moment(datetime).format(DATETIME_FORMAT) : EMPTY);

export const conversationIdColumn: ColumnType<AiccConversation> = {
  title: "Conversation ID",
  dataIndex: "id",
  key: "id",
  width: 240,
  ellipsis: true,
};

const getTrailingColumns = (onDelete: (conversationId: string) => void): ColumnType<AiccConversation>[] => [
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    width: 140,
    ellipsis: true,
    render: (_, { status }) => upperFirst(status),
  },
  {
    title: "Duration",
    dataIndex: "duration",
    key: "duration",
    width: 120,
    ellipsis: true,
    render: (_, { startedAt, completedAt }) => formatDuration(startedAt, completedAt),
  },
  {
    title: "Started At",
    dataIndex: "startedAt",
    key: "startedAt",
    width: 200,
    ellipsis: true,
    render: (_, { startedAt }) => formatDatetime(startedAt),
  },
  {
    title: "Completed At",
    dataIndex: "completedAt",
    key: "completedAt",
    width: 200,
    ellipsis: true,
    render: (_, { completedAt }) => formatDatetime(completedAt),
  },
  {
    title: "Conversation Fluency Level",
    dataIndex: "fluencyLevel",
    key: "fluencyLevel",
    width: 200,
    ellipsis: true,
    render: (_, { fluencyLevel }) => fluencyLevel ?? EMPTY,
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    fixed: "right",
    width: 220,
    render: (_, { id, status }) => {
      // Only a finished conversation can be deleted: an active one is still being
      // written to, so removing it mid-flight would race the session.
      const isDeletable = status === AICC_CONVERSATION_STATUS.completed;

      return (
        <Tooltip title={isDeletable ? "" : "Only a completed conversation can be deleted."}>
          <Button
            type="link"
            className={styles.deleteButton}
            disabled={!isDeletable}
            onClick={(event) => {
              event.stopPropagation();
              onDelete(id);
            }}
          >
            Delete
          </Button>
        </Tooltip>
      );
    },
  },
];

export default getTrailingColumns;
